/**
 * User: herbert
 * Date: 10.05.16
 * Time: 11:30
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

import React from 'react';

import steleActions from '../../actions/stele-actions';

import {W_ASYM, W_ASYM_PEDESTRIAN, W_ASYM_STREET, W_SYM} from '../../../../config';

import T from '../../../../nls/translate';

export default React.createClass({
	propTypes: {
		four: React.PropTypes.bool.isRequired,
		type: React.PropTypes.string.isRequired,
		k3000: React.PropTypes.bool.isRequired,
		k2xxx: React.PropTypes.bool.isRequired,
		sky: React.PropTypes.bool.isRequired,
		gold: React.PropTypes.bool.isRequired,
		parentIdx: React.PropTypes.number.isRequired
	},
	//_onTwoClick: function () {
	//	if(this.props.four)
	//		steleActions.changeSize(this.props.parentIdx, config.PART_MODUL_WEGE2);
	//},
	//_onFourClick: function () {
	//	if(!this.props.four)
	//		steleActions.changeSize(this.props.parentIdx, config.PART_MODUL_WEGE);
	//},
	_onSymClick: function () {
		if(this.props.type !== W_SYM)
			steleActions.setType(W_SYM, this.props.parentIdx);
	},
	_onAsymClick: function () {
		if(this.props.type !== W_ASYM)
			steleActions.setType(W_ASYM, this.props.parentIdx);
	},
	_onAsymPedestrianClick: function () {
		if(this.props.type !== W_ASYM_PEDESTRIAN)
			steleActions.setType(W_ASYM_PEDESTRIAN, this.props.parentIdx);
	},
	_onAsymStreetClick: function () {
		if(this.props.type !== W_ASYM_STREET)
			steleActions.setType(W_ASYM_STREET, this.props.parentIdx);
	},
	_onK2200Click: function () {
		if(!this.props.k3000 || !this.props.k2xxx) {
			steleActions.setLightColor(true, true, this.props.parentIdx);
		}
	},
	_onK2700Click: function () {
		if(this.props.k3000 || !this.props.k2xxx) {
			steleActions.setLightColor(true, false, this.props.parentIdx);
		}
	},
	_onK3000Click: function () {
		if(!this.props.k3000 || this.props.k2xxx) {
			steleActions.setLightColor(false, true, this.props.parentIdx);
		}
	},
	_onK4000Click: function () {
		if(this.props.k3000 || this.props.k2xxx) {
			steleActions.setLightColor(false, false, this.props.parentIdx);
		}
	},
	_onAmbianceClick: function () {
		if(this.props.sky) {
			steleActions.setSky(false, this.props.parentIdx);
		}
	},
	_onSkyClick: function () {
		if(!this.props.sky) {
			steleActions.setSky(true, this.props.parentIdx);
		}
	},
	_onGoldClick: function () {
		if(!this.props.gold) {
			steleActions.setGold(true, this.props.parentIdx);
		}
	},
	_onSilverClick: function () {
		if(this.props.gold) {
			steleActions.setGold(false, this.props.parentIdx);
		}
	},
	render: function () {
		return (
				<div className="slx-stele-summary__wege" >
					{/* // ACHTUNG wenn das wieder eingeschaltet wird, müssen die Hinweise auf 2-fach oder 4-fact wieder aus T.current.PRODUCTS.baseDescription getilgt werden, vgl. summary.renderPart
					<div className="slx-stele-summary__optiongroup">
						<div className={this.props.four ? 'slx-stele-summary__option' : 'slx-stele-summary__selected'} onClick={this._onTwoClick} >
							<img src="img/stele/summary/wege2.svg" className="slx-stele-summary__option-img" />
						</div>
						<div className={this.props.four ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onFourClick} >
							<img src="img/stele/summary/wege4.svg" className="slx-stele-summary__option-img" />
						</div>
					</div>
					*/}

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={'slx-stele-summary__option slx-stele-summary__option__tritec'} >
							<span className="slx-stele-summary__option-text">Tritec</span>
						</div>
						<div className={(!this.props.sky ? 'slx-stele-summary__selected slx-stele-summary__selected' : 'slx-stele-summary__option slx-stele-summary__option')+'__tritec-value'} onClick={this._onAmbianceClick} >
							<span className="slx-stele-summary__option-text">Ambiance</span>
						</div>
						<div className={(this.props.sky ? 'slx-stele-summary__selected slx-stele-summary__selected' : 'slx-stele-summary__option slx-stele-summary__option')+'__tritec-value'} onClick={this._onSkyClick} >
							<span className="slx-stele-summary__option-text">Sky</span>
						</div>
					</div>

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={(!this.props.gold ? 'slx-stele-summary__selected slx-stele-summary__selected' : 'slx-stele-summary__option slx-stele-summary__option')+'__tritec-value'} onClick={this._onSilverClick} >
							<span className="slx-stele-summary__option-text">{T.current.STELE.W_SILVER}</span>
						</div>
						<div className={(this.props.gold ? 'slx-stele-summary__selected slx-stele-summary__selected' : 'slx-stele-summary__option slx-stele-summary__option')+'__tritec-value'} onClick={this._onGoldClick} >
							<span className="slx-stele-summary__option-text">{T.current.STELE.W_GOLD}</span>
						</div>
					</div>

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.type === W_SYM ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onSymClick} >
							<img src="img/stele/parameters/Icon_eckig_black_4.png" className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.type === W_ASYM ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onAsymClick} >
							<img src="img/stele/parameters/Icon_eckig_black_5.png" className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.type === W_ASYM_PEDESTRIAN ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onAsymPedestrianClick} >
							<img src="img/stele/parameters/Icon_vert_down_near.png" className="slx-stele-summary__option-img48" />
						</div>
						<div className={this.props.type === W_ASYM_STREET ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onAsymStreetClick} >
							<img src="img/stele/parameters/Icon_vert_down.png" className="slx-stele-summary__option-img48" />
						</div>
					</div>

					<div className="slx-stele-summary__optiongroup slx-stele-summary__optiongroup--defaultHeight">
						<div className={this.props.k3000 && this.props.k2xxx ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onK2200Click} >
							<span className="slx-stele-summary__option-text">2200&nbsp;K</span>
						</div>
						<div className={!this.props.k3000 && this.props.k2xxx ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onK2700Click} >
							<span className="slx-stele-summary__option-text">2700&nbsp;K</span>
						</div>
						<div className={this.props.k3000 && !this.props.k2xxx ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onK3000Click} >
							<span className="slx-stele-summary__option-text">3000&nbsp;K</span>
						</div>
						<div className={!this.props.k3000 && !this.props.k2xxx ? 'slx-stele-summary__selected' : 'slx-stele-summary__option'} onClick={this._onK4000Click} >
							<span className="slx-stele-summary__option-text">4000&nbsp;K</span>
						</div>
					</div>
				</div>
		);
	}
});
/**
 * User: herbert
 * Date: 10.05.16
 * Time: 11:09
 */

